import React,{useEffect,useState} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Input,Tabs,Spin,Button,Divider, Empty  } from 'antd'
import {CHANNEL_DATA} from '../utils'
import {useMount, useRequest} from 'ahooks'
import OrderItem from './OrderItem'
import {getOrderCount,getLatestChannel,getBrandOrder} from '../service'
import styles from './OrderTabItem.module.less'
import { useRef } from 'react'
const { Search } = Input;
const { TabPane } = Tabs;
function OrderTabItem(props) {
  const defaultPageObj = {page_size:10,page_index:0}
  const {memberInfo,brandName} = props
  const [activeKey,setActiveKey] = useState('')
  const [lastChannel,setLastChannel] = useState({})
  const [orderTabData,setOrderTabData] = useState([])
  const [orderParams,setOrderParams] =useState({sale_store_code:'',order_code:'',page_size:10,page_index:0})
  const [orderData,setOrderData] = useState([])
  const [ifhasMore,setIfHasMore] = useState(false)
  const listWrapRef = useRef(null)
  const [keyWords,setKeywords] = useState('')
  // console.log('memberInfo',memberInfo)
  
  const {
    run:fetchGetOrderCount,
    loading:getOrderCountLoading
  } = useRequest (getOrderCount,
    {
      manual: true,
      onBefore:()=>{
      },
      onSuccess: (res) => {
        if(res){
          const sale_store_code = res[0].sale_store_code
          setActiveKey(sale_store_code)
          // setOrderParams((params)=>({...params,sale_store_code}))
          setOrderTabData(res.filter(e=>e.order_count>0).map(e=>({title:`${e.sale_store_name}(${e.order_count})`,value:e.sale_store_code})))
        }else{
          setOrderTabData([])
        }
      },
      onFinally:()=>{
      }
    },
  );
  const {
    run:fetchGetLatestChannel,
    loading:getLatestChannelLoading
  } = useRequest (getLatestChannel,
    {
      manual: true,
      onBefore:()=>{
      },
      onSuccess: (res) => {
        if(res){
          setLastChannel(res)
        }else{
          setLastChannel({})
        }
      },
      onFinally:()=>{
      }
    },
  );
  const {
    run:fetchGetBrandOrder,
    loading:getBrandOrderLoading
  } = useRequest (({params,ifSearch})=>{
    const _params = _.cloneDeep(params)
    if(ifSearch){
      _params.sale_store_code = undefined
    }
    return getBrandOrder(_params)
  },
    {
      manual: true,
      onBefore:()=>{
      },
      onSuccess: (res,params) => {
        const ifLoad= params[0].ifLoad
        if(res){
          setIfHasMore(res.length==orderParams.page_size)
          if(ifLoad){
            setOrderData((_data)=>{
              return [..._data,...res]
            })
          }else{
            setOrderData(res)
          }
        }else{
          setIfHasMore(false)
          if(ifLoad){
          }else{
            setOrderData([])
          }
        }
      },
      onFinally:(params)=>{
        if(params[0].params.page_index==0){
          listWrapRef.current.scrollTo(0,0)
        }
      }
    },
  );
  useEffect(()=>{
    if(memberInfo.brandId && memberInfo.phone){
      const {brandId,phone} = memberInfo
      fetchGetOrderCount({brand_id:brandId,phone})
      fetchGetLatestChannel({brand_id:brandId,phone})
    }
  },[memberInfo.brandId,memberInfo.phone])

  const getResetParams = (obj)=>{
    const _parmas = _.cloneDeep(orderParams)
    const _p = {..._parmas,...defaultPageObj,...obj}
    return _p 
  }
  useEffect(()=>{
    const {brandId,phone} = memberInfo
    if(orderTabData.length){
      const sale_store_code = orderTabData[0].value
      const _p = {...getResetParams({sale_store_code}),brand_id:brandId,phone}
      setOrderParams(_p)
      fetchGetBrandOrder({params:_p,ifLoad:false})
    }
  },[JSON.stringify(orderTabData)])
  
  const tabChange=(v)=>{
    setActiveKey(v)
    setKeywords('')
    const _p = {...getResetParams({sale_store_code:v,order_code:''})}
    setOrderParams(_p)
    fetchGetBrandOrder({params:_p,ifLoad:false})
  }
  const loadMore=()=>{
    setKeywords('')
    const _p = {...getResetParams({sale_store_code:orderParams.sale_store_code,order_code:''}),page_index:orderParams.page_index+1}
    setOrderParams(_p)
    fetchGetBrandOrder({params:_p,ifLoad:true})
  }
  const searchFn=(v)=>{
    const _p = {...getResetParams({order_code:v})}
    setOrderParams(_p)
    fetchGetBrandOrder({params:_p,ifLoad:false,ifSearch:v.length?true:false})
  }
  // const ifhasMore= orderData.length
  return (
    <div className={styles.OrderTabItem} style={{width:300,padding:'0 16px 16px 8px'}}>
      <Search style={{width:'100%',marginBottom:4}} value={keyWords} onChange={(e)=>{setKeywords(e.target.value)}} allowClear onSearch={searchFn} placeholder='搜索渠道单号/ERP订单号'></Search>
      <Spin spinning={getLatestChannelLoading}>
        <div style={{margin:'8px auto'}}>
          最近一次购买渠道：
         <a style={{textDecoration:'underLine',fontWeight:600}} href='javascript:;' onClick={()=>{
          if(_.get(lastChannel,'channel_code')){
            tabChange(_.get(lastChannel,'channel_code'))
          }
         }}>{_.get(lastChannel,'channel_name','-')}</a> 
        </div>
      </Spin>
      {/* <Search style={{width:'100%',marginBottom:4}} placeholder='搜索渠道单号/ERP订单号'></Search> */}
      <Tabs activeKey={activeKey} onChange={tabChange} size='small' loading={getOrderCountLoading} style={{backgrounnd:'#fff'}}>
        {orderTabData.map(item => (
          <TabPane tab={item.title} key={item.value}>
          </TabPane>
        ))}
      </Tabs>
      <Spin spinning={getBrandOrderLoading}>
        <div style={{maxHeight:712,overflow:'auto',paddingRight:4}} ref={listWrapRef}>
          {orderData.length?
          orderData.map(e=>{
            return (
              <OrderItem data={e} brandName={brandName} key={e.erp_order_code}></OrderItem>
            )
          }):<Empty></Empty>}
          {ifhasMore?<Divider><Button onClick={loadMore} type='link'>加载更多</Button></Divider>:<Divider>已经到底了</Divider>}
        </div>
      </Spin>
    </div>
  )
}

OrderTabItem.propTypes = {
  brandName:PropTypes.string.isRequired,
  memberInfo:PropTypes.object.isRequired
}
OrderTabItem.defaultProps={
  memberInfo:{},
  brandName:''
}
export default OrderTabItem



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/OrderTabItem.js